import React from "react";
import i18n from "i18n-react";
import PropTypes from 'prop-types';

let html = "";
let values;

export const DynamicMapShow = (props) => {
    let html = "";
    values = JSON.parse(props.array.value);
    html += createDynamicMapHtml(values);

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>

    )
}
export const DynamicMap = (props) => {

    let detail = props.array;
    html = "";

    detail.detail.map((elem) => {
        if (!detail.show) {
            html += "<li>";
            if (elem.type === 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
                html += "<br>";
            } else {
                html += "<b>" + elem.description + "</b>";
                html += "<br>";
            }
        }
        values = JSON.parse(elem.value);
        html += createDynamicMapHtml(values);

        if (!detail.show) {
            html += "</li>";
        }
    })

    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <span dangerouslySetInnerHTML={{ __html: html }}></span>
        )
    }
};

DynamicMap.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number,
                description: PropTypes.string,
                value: PropTypes.string
            })
        )
    })
};

DynamicMap.defaultProps = {
    array: {
        show: false,
        detail: []
    }
};

export const ArrayStringShow = (props) => {
    let count = 1;
    let html = "";
    values = JSON.parse(props.array.value);
    values.map((e) => {
        html += count + " - " + e;
        html += "<br>";
        count++;
    });
    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>

    )
}

// MultipleSelectedOptionShow is implemented later in this file (below).

export const ArrayString = (props) => {
    let detail = props.array;
    let count = 1;
    let img;
    html = "";

    detail.detail.map((elem) => {
        if (!detail.show) {
            html += "<li>";
            if (elem.type == 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
                html += "<br>";
            } else {
                html += "<b>" + elem.description + "</b>";
                html += "<br>";
            }
        }
        values = JSON.parse(elem.value);
        values.map((e) => {
            html += count + " - " + e;
            html += "<br>";
            count++;
        });
        if (!detail.show) {
            html += "</li>";
        }
    })

    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <span dangerouslySetInnerHTML={{ __html: html }}></span>
        )
    }
};



export const IntervalDayAndHourShow = (props) => {
    let intervals, daysAndHours, daysToSplit, hoursToSplit, days, hours;
    let daysToShow = [];
    let html = "";
    intervals = props.array.value.split("|");
    for (let i = 0; i < intervals.length; i++) {
        daysAndHours = intervals[i].split(";");
        daysToSplit = daysAndHours[0];
        hoursToSplit = daysAndHours[1];
        days = daysToSplit.split(",");
        hours = hoursToSplit.split("-");
        daysToShow = createIntervalDayAndHourHtml(days);

        html += daysToShow;
        html += hours;
        html += "<br>";
        daysToShow = [];
    }
    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>

    )
}

const populateCheckDays = (days, checkDays) => {
    const DAYS_MAP = {
        "1": "monday", "2": "tuesday", "3": "wednesday", "4": "thursday",
        "5": "friday", "6": "saturday", "7": "sunday"
    };
    for (let k = 0; k < days.length; k++) {
        const targetDay = DAYS_MAP[days[k]];
        if (targetDay) {
            checkDays[targetDay] = true;
        }
    }
};

export const IntervalDayAndHour = (props) => {
    console.log("IntervalDayAndHour", props.array);
    let detail = props?.array;
    if (!detail?.detail) return null;

    let img;
    let rowCounts = 0;
    const optionsHour = [
        { value: '00' }, { value: '01' }, { value: '02' }, { value: '03' }, { value: '04' }, { value: '05' }, { value: '06' },
        { value: '07' }, { value: '08' }, { value: '09' }, { value: '10' }, { value: '11' }, { value: '12' }, { value: '13' },
        { value: '14' }, { value: '15' }, { value: '16' }, { value: '17' }, { value: '18' }, { value: '19' }, { value: '20' },
        { value: '21' }, { value: '22' }, { value: '23' }
    ]
    const optionsMinute = [
        { value: "00" }, { value: "05" }, { value: "10" }, { value: "15" }, { value: "20" }, { value: "25" }, { value: "30" },
        { value: "35" }, { value: "40" }, { value: "45" }, { value: "50" }, { value: "55" },
    ]

    let html = "";
    let intervals, interval1, interval2, days;
    let daysHour, daysForSplit, hourForSplit, hours;
    let checkDays = { "monday": false, "tuesday": false, "wednesday": false, "thursday": false, "friday": false, "saturday": false, "sunday": false };
    let checkHours;
    let d = [];
    let h = [];
    let checkTimeHour = [];
    let dayTime = [];

    for (let i = 0; i < detail.detail.length; i++) {
        intervals = detail.detail[i].value.split("|");
        for (let j = 0; j < intervals.length; j++) {
            daysHour = intervals[j].split(";");
            daysForSplit = daysHour[0];
            days = daysForSplit.split(",");
            hourForSplit = daysHour[1];
            hours = hourForSplit.split("-");
            checkHours = hourForSplit.split("-");

            populateCheckDays(days, checkDays);

            d.push(checkDays);
            h.push(hours);
            hours.push(checkDays);
            checkTimeHour.push(hours)
            checkDays = { "monday": false, "tuesday": false, "wednesday": false, "thursday": false, "friday": false, "saturday": false, "sunday": false };
        }
    }

    if (detail.show) {
        return <span dangerouslySetInnerHTML={{ __html: html }}></span>;
    }
    for (const item of detail.detail) {
        html += "<li>";

        if (item.type === 0) {
            html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
            html += "<br>";
        } else {
            html += "<b>" + item.description + "</b>";
            html += "<br>";
        }

        intervals = item.value.split("|");

        for (const interval of intervals) {
            daysHour = interval.split(";");
            daysForSplit = daysHour[0];
            days = daysForSplit.split(",");
            hourForSplit = daysHour[1];
            hours = hourForSplit.split("-");
            checkHours = hourForSplit.split("-");
            dayTime = createIntervalDayAndHourHtml(days);

            d.push(checkDays);
            h.push(hours);
            hours.push(checkDays);
            checkTimeHour.push(hours);

            html += dayTime;
            html += " ";
            html += checkHours;
            html += "<br>";
            dayTime = [];
        }
        html += "</li>";
    }

    return (
        <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
    );
}

export const BooleanShow = (props) => {
    let html = "";
    html += "<label>";
    if (props.array.value === "true") {
        html += String(i18n.translate("true"));
    } else {
        html += String(i18n.translate("false"));
    }
    html += "</label>";
    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>

    )
}

export const Boolean = (props) => {
    let detail = props.array;
    html = "";
    detail.detail.map((elem) => {
        if (!detail.show) {
            html += "<li>";
            if (elem.type === 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
            } else {
                html += "<b>" + elem.description + ": </b>";
            }
        }
        html += "<label>";
        if (elem.value === "true") {
            html += String(i18n.translate("true"));
        } else {
            html += String(i18n.translate("false"));
        }
        html += "</label>";
        if (!detail.show) {
            html += "</li>";
        }
    })
    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
            </div>

        )
    }
}

export const ArrayOfMap = (props) => {

    let detail = props.array;
    html = "";
    detail.detail.map((elem) => {
        if (!detail.show) {
            html += "<li>";
            if (elem.type === 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
                html += "<br>";
            } else {
                html += "<b>" + elem.description + "</b>";
                html += "<br>";
            }
        }
        values = JSON.parse(elem.value);
        html += createArrayOfMapHtml(values);
        if (!detail.show) {
            html += "</li>";
        }
    })
    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <span dangerouslySetInnerHTML={{ __html: html }}></span>
        )
    }
};

export const ArrayOfMapShow = (props) => {
    let html = "";
    values = JSON.parse(props.array.value);
    html += createArrayOfMapHtml(values);

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>

    )
}

const createBooleanHtml = (value) => {
    let html = "";
    if (value === "true") {
        html += String(i18n.translate("true"));
    } else {
        html += String(i18n.translate("false"));
    }
    html += "<br>";
    return html;
}

const createIntervalDayAndHourHtml = (days) => {
    let dayTime = [];
    for (let k = 0; k < days.length; k++) {
        if (days[k] === "1") {
            dayTime.push(i18n.translate("monday"));
        } else if (days[k] === "2") {
            dayTime.push(i18n.translate("tuesday"));
        } else if (days[k] === "3") {
            dayTime.push(i18n.translate("wednesday"));
        } else if (days[k] === "4") {
            dayTime.push(i18n.translate("thursday"));
        } else if (days[k] === "5") {
            dayTime.push(i18n.translate("friday"));
        } else if (days[k] === "6") {
            dayTime.push(i18n.translate("saturday"));
        } else if (days[k] === "7") {
            dayTime.push(i18n.translate("sunday"));
        }
    }
    return dayTime;
}

const createSettingHtml = (key, setting) => {
    if (!setting) return "";
    const value = setting.value == "true" ? String(i18n.translate("true")) : String(i18n.translate("false"));
    return "<span style='padding-left: 16px;'><b>" + String(i18n.translate(key)) + ": </b>" + value + "</span><br>";
}

const createStandardDurationSettingHtml = (setting) => {
    if (!setting) return "";
    return "<span style='padding-left: 16px;'><b>" + String(i18n.translate("standard_duration")) + ": </b>" +
        setting.value + " " + String(i18n.translate("default_minutes")) + "</span><br>";
}

const createTasksToDoSettingHtml = (setting) => {
    if (!setting) return "";
    const tasksHtml = setting.value.map((task, j) => (j !== 0 ? ", " + task : task)).join("");
    return "<span style='padding-left: 16px;'><b>" + String(i18n.translate("tasks_to_do")) + ": </b>" + tasksHtml + "</span><br>";
}

const createArrayOfMapHtml = (values) => {
    let html = "";

    values.map((val, i) => {
        html += "<b>" + (i + 1) + " - " + val.type + "</b>";
        html += "<br>";
        html += createSettingHtml("required_start_photo", val.settings.required_start_photo);
        html += createSettingHtml("required_end_photo", val.settings.required_end_photo);
        html += createSettingHtml("required_signature", val.settings.required_signature);
        html += createSettingHtml("on_demand", val.settings.on_demand);
        html += createStandardDurationSettingHtml(val.settings.standard_duration);
        html += createTasksToDoSettingHtml(val.settings.tasks_to_do);
    })

    return html;
}

const createDynamicMapHtml = (values) => {
    let html = "";
    Object.keys(values).forEach((e) => {
        html += "<b>" + i18n.translate(e) + " </b>:";
        if (values[e].type === 'boolean' || values[e].type === 'BOOLEAN') {
            html += createBooleanHtml(values[e].value);
        } else if (values[e].type === 'numeric' || values[e].type === 'int') {
            html += values[e].value;
            html += "<br>";
        } else if (values[e].type === 'ARRAY_STRING') {
            values[e].value.map((e) => {
                html += "<br>";
                html += e;
            })
        }
    });
    return html;
}

export const DynamicSelectedValues = (props) => {
    let html = "";
    let detail = props.array;
    detail.detail.map((elem, i) => {
        if (!detail.show) {
            html += "<li>";
            if (elem.type === 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
            } else {
                html += "<b>" + elem.description + ": </b>";
            }
        }
        html += "<label>";
        const parsedValue = DynamicSelectedValuesParseValue(detail.key, elem.value);
        html += (typeof parsedValue === 'object' && parsedValue !== null)
            ? (parsedValue.label || parsedValue.value || JSON.stringify(parsedValue))
            : String(parsedValue || '');
        html += "</label>";
        if (!detail.show) {
            html += "</li>";
        }
    })
    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
            </div>

        )
    }
}
DynamicSelectedValues.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        key: PropTypes.string,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number,
                description: PropTypes.string,
                value: PropTypes.any
            })
        )
    })
};

DynamicSelectedValues.defaultProps = {
    array: {
        show: false,
        key: "",
        detail: []
    }
};

const DynamicSelectedValuesParseValue = (configKey, value) => {
    if (!configKey || !value) {
        return "";
    }
    return String(i18n.translate(`${configKey}_${value}`) || "");
};

export const DynamicSelectedValuesShow = ({ config, configValue }) => {

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label>
                {DynamicSelectedValuesParseValue(config.key, configValue.value)}
            </label>
        </div>
    );
};

DynamicSelectedValuesShow.propTypes = {
    config: PropTypes.shape({
        key: PropTypes.string
    }),
    configValue: PropTypes.shape({
        value: PropTypes.any
    })
};

DynamicSelectedValuesShow.defaultProps = {
    config: {
        key: ""
    },
    configValue: {
        value: ""
    }
};

export const DynamicInputValue = (value) => {

    let html = "";

    let detail = value.array;
    let data;

    detail.detail.map((elem, i) => {

        if (!detail.show) {
            html += "<li>";
            if (elem.type === 0) {
                html += "<b>" + i18n.translate("default_predeterminated") + ": </b>";
            } else {
                html += "<b>" + elem.description + ": </b>";
            }
        }

        html += "<label>";

        data = JSON.parse(elem.value);

        data.map((item, index) => {

            if ((item.type === "numeric" && Number(item.value) !== 0) || item.type !== "numeric") {

                html += "</li>";
                html += i18n.translate(item.key);
                html += ": ";

                if (item.type === "numeric" || item.type === "int") {
                    html += item.value;
                } else if (item.type === "boolean" || item.type === "BOOLEAN") {
                    html += i18n.translate(item.value)
                } else {
                    html += item.value;
                }
                html += "</li>";

            }

            html += "<br>";

        });


        html += "</label>";
        if (!detail.show) {
            html += "</li>";
        }

    })


    if (!detail.show) {
        return (
            <ul dangerouslySetInnerHTML={{ __html: html }}></ul>
        );
    } else {
        return (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
            </div>

        )
    }

}

export const DynamicInputValueShow = (value) => {

    let html = "";

    let obj = value.array;

    if (typeof obj.value === "string") {
        obj.value = JSON.parse(obj.value)
    }

    obj.value.map((item, index) => {

        if ((item.type === "numeric" && Number(item.value) !== 0) || item.type !== "numeric") {

            html += "</li>";
            html += i18n.translate(item.key);
            html += ":";

            if (item.type === "numeric" || item.type === "int") {
                html += item.value;
            } else if (item.type === "boolean" || item.type === "BOOLEAN") {
                html += i18n.translate(item.value)
            } else {
                html += item.value;
            }
            html += "</li>";

        }

        html += "<br>";

    });


    html += "</label>";

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12" dangerouslySetInnerHTML={{ __html: html }}>
        </div>
    )

}

export const MultipleSelectedOptionShow = ({ array, configKey }) => {
    if (!array?.value) return <span>---</span>;

    const values = array.value.toString().split(",");

    return (
        <div className="d-flex flex-wrap gap-1">
            {values.map((v) => (
                <span key={`badge-${v}`} className="badge bg-info text-white me-1" style={{ fontSize: '0.85rem' }}>
                    {i18n.translate(`${configKey}_${v}`)}
                </span>
            ))}
        </div>
    );
};
MultipleSelectedOptionShow.propTypes = {
    array: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    configKey: PropTypes.string
};

MultipleSelectedOptionShow.defaultProps = {
    array: null,
    configKey: ""
};

export const MultipleSelectedOptionShowTemplate = ({ array, configKey }) => {
    const rawValue = array?.detail?.[0]?.value || array?.value;

    if (!rawValue) return <span>---</span>;

    const values = rawValue.toString().split(",");

    return (
        <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
            <li >
                {/* Texto "Predeterminado:" con estilo de etiqueta */}
                <span style={{ fontWeight: 'bold' }}>
                    {i18n.translate("default_predeterminated")}:
                </span>

                {/* Valores traducidos y unidos por comas */}
                <span>
                    {values.map((val, index) => {
                        const translatedLabel = String(i18n.translate(`${configKey}_${val}`));
                        return index === values.length - 1
                            ? translatedLabel
                            : `${translatedLabel}, `;
                    })}
                </span>
            </li>
        </ul>
    );
};
MultipleSelectedOptionShowTemplate.propTypes = {
    array: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        )
    }),
    configKey: PropTypes.string
};
MultipleSelectedOptionShowTemplate.defaultProps = {
    array: null,
    configKey: ""
};

IntervalDayAndHour.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number,
                description: PropTypes.string,
                value: PropTypes.string
            })
        )
    })
};

ArrayString.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number
            })
        )
    })
};

DynamicInputValue.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number,
                description: PropTypes.string,
                value: PropTypes.string
            })
        )
    })
};
Boolean.propTypes = {
    array: PropTypes.shape({
        show: PropTypes.bool,
        detail: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number,
                description: PropTypes.string,
                value: PropTypes.string
            })
        )
    })
};